// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function appliesToToString(value) {
  switch (value) {
    case "FeedImport" :
        return "feed_import";
    case "SurveyTrigger" :
        return "survey_trigger";
    case "Both" :
        return "both";
    
  }
}

function appliesToLabel(value) {
  switch (value) {
    case "FeedImport" :
        return "Feed import";
    case "SurveyTrigger" :
        return "Survey trigger";
    case "Both" :
        return "Both pipelines";
    
  }
}

function appliesToFromString(value) {
  switch (value) {
    case "feed_import" :
        return "FeedImport";
    case "survey_trigger" :
        return "SurveyTrigger";
    default:
      return "Both";
  }
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          enabled: true,
          priority: 100,
          appliesTo: "Both",
          definition: JSON.parse("{\"version\":1,\"actions\":[]}")
        };
}

function decode(json) {
  var obj = Js_json.decodeObject(json);
  var definition = obj !== undefined ? Belt_Option.getWithDefault(Js_dict.get(obj, "definition"), null) : null;
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          enabled: Json_decode.field("enabled", Json_decode.bool, json),
          priority: Json_decode.field("priority", Json_decode.$$int, json),
          appliesTo: appliesToFromString(Json_decode.field("applies_to", Json_decode.string, json)),
          definition: definition
        };
}

function encode(rule) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), rule.id)
              ],
              tl: {
                hd: [
                  "name",
                  rule.name
                ],
                tl: {
                  hd: [
                    "enabled",
                    rule.enabled
                  ],
                  tl: {
                    hd: [
                      "priority",
                      rule.priority
                    ],
                    tl: {
                      hd: [
                        "applies_to",
                        appliesToToString(rule.appliesTo)
                      ],
                      tl: {
                        hd: [
                          "definition",
                          rule.definition
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

exports.appliesToToString = appliesToToString;
exports.appliesToLabel = appliesToLabel;
exports.appliesToFromString = appliesToFromString;
exports.empty = empty;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
